
















































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseSortIcons from '@/ui/BaseSortIcons.vue';
// Importing functions
import {getDeliveryOrders} from '@/ts/deliveries/get-delivery-orders';
import {putOrder} from '@/ts/orders/put-order';
import {finishDelivery} from '@/ts/deliveries/finish-delivery';
// Importing variables
import {OrderOptions, SuccessfulAction, SuccessfullyDelivered} from '@/ts/variables';

export default {
    name: 'TheTableDeliveryOrders',
    components: {
        BaseButton,
        BaseLoadingAnimation,
        BaseSortIcons,
    },
    props: {},
    data() {
        return {
            options: [],
        };
    },
    methods: {
        sort(temp) {
            this.$store.dispatch('setOrderParam', temp.order_param);
            this.$store.dispatch('setSortParam', temp.sort_param);
            this.$store.dispatch('setLoadingOn');
            getDeliveryOrders().finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
        refreshItem(event, id) {
            this.$store.dispatch('setLoadingOn');
            putOrder(id, this.$route.params.id, event).finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
        finish(id) {
            finishDelivery(id).then(() => {
                this.$swal.fire(SuccessfulAction, SuccessfullyDelivered, 'success').then(() => {
                    this.$router.go(-1);
                });
            });
        },
        startDelivery(id) {
            this.$router.push({ name: 'start-delivery', params: { id: this.$route.params.id, order_id: id} });
        },
    },
    created() {
        this.options = OrderOptions;
    },
};
